import React from "react";

const Payments = () => {
    return <h2>Manage Payments</h2>;
  };
  
  export default Payments;
  